import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Paragraph, Text } = Typography;

export default function NotificationsPage(): React.ReactElement {
  return (
    <Card style={{ margin: 24 }}>
      <Title level={3} style={{ marginBottom: 8 }}>
        Notifications
      </Title>
      <Paragraph>
        Access Control notifications are still backed by the local real-time event channel. This
        page stays lightweight until the shared tenant-scoped admin inbox backend is adopted.
      </Paragraph>
      <Paragraph type="secondary">
        Live local notifications continue to appear from the app header while the shared inbox
        history and filtering surface is built out.
      </Paragraph>
      <Text type="secondary">Return to this page for new alerts and announcements.</Text>
    </Card>
  );
}
